"use client";

import { useTheme } from "next-themes";
import type * as React from "react";
import { createPortal } from "react-dom";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const SonnerToaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  const toasterContent = (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "z-[10000] group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:pointer-events-auto",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          error:
            "group destructive border-destructive bg-destructive text-destructive-foreground",
          warning:
            "group warning border-yellow-500 bg-yellow-500 text-yellow-500-foreground",
          success:
            "group success border-green-500 bg-green-500 text-green-500-foreground",
        },
      }}
      {...props}
    />
  );

  // Only render in the browser
  if (typeof window === "undefined") return null;

  if (!document.getElementById("sonner-viewport")) return null;

  return createPortal(toasterContent, document.body);
};

export { SonnerToaster };
